import React from 'react';
import Table from 'react-bootstrap/Table';
import { Link } from 'react-router-dom';
import trash_icon from '../../../assets/images/icons/user-dashboard/trash-icon.png';
import CustomModalView from '../../../common/input/customModal/customModalView';
import { Navigate } from 'react-router-dom';
import CommonTableModalView from '../common-table/CommonTableModelView';
import ShiftModalView from '../ShiftModelView';

const PrivateJobView = (props) => {
  // if (localStorage.getItem("token") != null && localStorage.getItem("is_admin")) {
  return (
    <>
      <div className="dashboard-body-area" style={{ width: '100%' }}>
        <section className="dashboard-page-title">
          <div className="row justify-content-md-center">
            <div className="col-md-4 findjob-search-bar">
              <div className="cc-searchbar" style={{ width: '95%' }}>
                <div className="srch-fld-row">
                  <div
                    className="srch-fld-col"
                    style={{ width: '82%', borderRight: '0px' }}
                  >
                    <input type="text" placeholder="Postcode" />
                  </div>

                  <div className="srch-fld-col srch-btn-col">
                    <input type="submit" value="" className="form-submit-btn" />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4 ">
              <div className="form-group">
                <select
                  id="inputcare"
                  className="cc-searchbar form-control"
                  style={{ height: '59px' }}
                >
                  <option>Column View</option>
                </select>
              </div>
            </div>
            <div className="col-md-3 ">
              <div className="form-group">
                <select
                  id="inputcare"
                  className="cc-searchbar form-control"
                  style={{ height: '59px' }}
                >
                  <option>Status</option>
                </select>
              </div>
            </div>
          </div>
        </section>
        <section className="dashboard-page-title">
          <h2>Private Job's</h2>
        </section>
        <div className="table-area applied-job-table">
          <Table responsive>
            <thead>
              <tr>
                <th>Id</th>
                <th>Job Number</th>
                <th>Shifts</th>
                <th>Title</th>
                <th>Postcode</th>
                <th>phone</th>
                <th>care type</th>
                <th>Job type</th>
                <th>Contract type</th>
                <th>Renumeration</th>
                <th>Closing Date</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {props.job_detail.map((jobs, index) => (
                <tr>
                  <td>{jobs.id}</td>
                  <td>{jobs.job_number}</td>
                  {jobs.shift_count > 0 ? (
                    <td
                      className="shift-private"
                      onClick={(e) => props.handleshift(jobs.id)}
                    >
                      {jobs.shift_count}
                    </td>
                  ) : (
                    <td className="shift-private">0</td>
                  )}
                  <td>{jobs.title}</td>
                  <td>{jobs.postcode}</td>
                  <td>{jobs.phone_number}</td>
                  <td>{props.carer_type_arr[jobs.carer_type]}</td>
                  <td>{jobs.job_type}</td>
                  <td>{props.contract_type_arr[jobs.contract_type]}</td>
                  <td>{jobs.renumerate}</td>
                  <td>{jobs.close_date}</td>
                  <td>{jobs.status}</td>
                  <td>
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                      <div>
                        {' '}
                        <Link
                          href=""
                          onClick={(e) => props.handleapplicant(jobs.id)}
                          className="del_btn"
                        >
                          <i
                            style={{
                              marginRight: '0 8px',
                              color: 'black',
                              fontSize: '16px',
                            }}
                            class="fa fa-list fa-lg"
                            aria-hidden="true"
                          ></i>
                        </Link>
                      </div>
                      <div>
                        {' '}
                        <Link
                          href=""
                          onClick={(e) => props.handlepreview(jobs.id)}
                          className="del_btn"
                        >
                          <i
                            style={{
                              marginRight: '0 8px',
                              color: 'black',
                              marginLeft: '10px',
                              fontSize: '16px',
                            }}
                            class="fa fa-eye fa-lg"
                            aria-hidden="true"
                          ></i>
                        </Link>
                      </div>
                      <div>
                        {' '}
                        <Link
                          href=""
                          className="del_btn"
                          onClick={(e) => props.handledelete(jobs.id)}
                        >
                          <img
                            style={{ margin: '0 8px', width: '16px' }}
                            src={trash_icon}
                          />
                        </Link>{' '}
                      </div>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </div>
      <CustomModalView
        modal_show={props.modal_show}
        authResponse={props.authResponse}
        showCustomModal={props.showCustomModal}
        hideCustomModal={props.hideCustomModal}
      />
      <CommonTableModalView
        modal_table_show={props.modal_table_show}
        hideTableModal={props.hideTableModal}
        application_detail={props.application_detail}
      />
      {/* <ShiftModalView
        hideShiftModal={props.hideShiftModal}
        shift_modal_show={props.shift_modal_show}
        shift_detail={props.shift_detail}
      /> */}
    </>
  );
  // }
  // else if (localStorage.getItem("token") == null) {
  //     return (
  //         <Navigate to="/login" />
  //     )
  // }
  // else {
  //     return (
  //         <Navigate to="/dashboard" />
  //     )
  // }
};

export default PrivateJobView;
